import React from 'react';
import { LoginOutlined, LogoutOutlined, PhoneOutlined } from '@ant-design/icons';

// Resumo da reserva no topo da ficha (staff): o essencial do check-in/check-out sem fazer scroll
const ResumoReserva = ({ dados, idReserva, estadodopagamento, valorExtra }) => {
    const modelo = dados.modelo !== 'a:0:{}' ? dados.modelo : '';
    const pago = estadodopagamento === 'Pago' || estadodopagamento === 'Pago Saída';
    const extra = Number(valorExtra) || 0;

    return (
        <div className="resumo-reserva-staff">
            <div className="resumo-reserva-linha">
                <span className="resumo-reserva-matricula">{dados.matricula}</span>
                <span className="resumo-reserva-carro">{dados.marca} {modelo}</span>
            </div>
            <div className="resumo-reserva-linha">
                <span className="resumo-reserva-id">#{idReserva}</span>
                <span className={`estado-chip estado-chip-${(dados.estadodareserva || '').toLowerCase()}`}>{dados.estadodareserva}</span>
                <span className={`estado-chip ${pago ? 'estado-chip-pago' : 'estado-chip-por-pagar'}`}>{estadodopagamento}</span>
            </div>
            <div className="resumo-reserva-cliente">
                <span className="resumo-reserva-nome">{dados.primeiro_nome} {dados.ultimo_nome}</span>
                {dados.telemovel && (
                    <a className="resumo-reserva-ligar" href={`tel:${dados.telemovel}`}>
                        <PhoneOutlined /> {dados.telemovel}
                    </a>
                )}
            </div>
            <div className="resumo-reserva-datas">
                <span><LoginOutlined /> <b>{dados.dia_de_entrada}</b> {dados.horario_de_entrada}</span>
                <span><LogoutOutlined /> <b>{dados.dia_de_saida}</b> {dados.horario_de_saida}</span>
            </div>
            <div className="resumo-reserva-extra">
                {dados.espacoparque} · <b>{dados.preco_total_a_pagar} €</b>{extra > 0 ? ` (+${extra} € extra)` : ''}
            </div>
        </div>
    );
};

export default ResumoReserva;
